import { isObject, trimCharsEnd } from 'lodash/fp';

import { History, UseLocation } from '@skippay/core/hooks/useLocation';
import { createHref } from '@skippay/core/utils/routeUtils';
import { isAbsoluteURL } from '@skippay/core/utils/urlUtils';

import { QUERY_PARAM_AFTER_LOGIN } from 'constants/queryAndStorageKeys';
import { APPLICATION_LISTING, DEFERRED_PAYMENTS, PAYMENT_GATEWAY } from 'constants/routes';

export { createHref };

export function getApplicationListingRoute(
	isDeferredPaymentsEnabled: boolean,
	hasBilling = false
): string {
	return !hasBilling && isDeferredPaymentsEnabled ? DEFERRED_PAYMENTS : APPLICATION_LISTING;
}

const trimTrailingSlash = trimCharsEnd(`/`);

export function createAbsoluteHref(
	location: Partial<UseLocation> | string,
	baseUrl: string
): string {
	const stringLocation = isObject(location) ? createHref(location) : location;
	return isAbsoluteURL(stringLocation)
		? stringLocation
		: baseUrl + trimTrailingSlash(stringLocation);
}

export function hasHistoryStack(history: History): boolean {
	return !!history.length && !history.location.state?.[QUERY_PARAM_AFTER_LOGIN];
}

export function normalizePathname(pathname: string): string {
	const path = pathname.toLowerCase();
	return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function matchesRouteSegment(path: string, route: string): boolean {
	return path === route || path.startsWith(`${route}/`);
}

export function isPaymentGatePathname(pathname: string): boolean {
	return matchesRouteSegment(normalizePathname(pathname), PAYMENT_GATEWAY);
}
